import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const drmCreateCustomColumn = async ([
  body,
]) => {
  const response = await axios.post(
    URLS.DRM_CUSTOM_COLUMN_CREATE_UPDATE,
    body,
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
